import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { paths } from '@fleet/environment';

import { AuthApiService } from '@fleet/api/auth/auth-api.service';
import { ValidationApiService } from '@fleet/api/validation/validation-api.service';
import { VerificationApiService } from '@fleet/api/verification/verification-api.service';
import { handleApiError } from '@fleet/utilities';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';

import { Router } from '@angular/router';
import { LoginModel, TravellerModel, VerificationModel } from '@fleet/model';
import { NetworkGroupHeaderService } from '@fleet/token/network-group-header/network-group-header.service';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class TravellerAuthService extends AuthService {
  nonAuthorisedHttp: HttpClient;
  user: TravellerModel;
  verificationModel: VerificationModel;

  fleetHeaders: HttpHeaders = new HttpHeaders({
    'fleet-channel': 'WEB',
    'fleet-product': 'TRAVELLER',
  });

  constructor(
    // private http: HttpClient,
    private backend: HttpBackend,
    authApiService: AuthApiService,
    verificationApiService: VerificationApiService,
    validationApiService: ValidationApiService,
    store: Store<any>,
    router: Router,
    http: HttpClient,
    @Inject('env') env: any,
    networkGroupHeaderService: NetworkGroupHeaderService
  ) {
    super(
      authApiService,
      verificationApiService,
      router,
      validationApiService,
      store,
      http,
      env,
      networkGroupHeaderService
    );
    this.nonAuthorisedHttp = new HttpClient(backend);
    this.host = env.host + paths.traveller;
  }

  signup(payload: any) {
    const headers: HttpHeaders = new HttpHeaders({
      'fleet-product': 'TRAVELLER',
      'fleet-channel': 'WEB',
    });
    return this.nonAuthorisedHttp
      .post(`${this.host}/signup`, payload, {
        headers: headers,
        observe: 'response',
      })
      .pipe(catchError(handleApiError));
  }

  signIn(login: LoginModel) {
    const authdata = btoa(login.username + ':' + login.password);
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: 'Basic ' + authdata,

      'fleet-product': 'TRAVELLER',
      'fleet-channel': 'WEB',
    });

    return this.nonAuthorisedHttp
      .post(`${this.host}/signin`, null, {
        headers: headers,
        observe: 'response',
      })
      .pipe(catchError(handleApiError));
  }

  getUser(payload: any) {
    return this.http
      .get(`${this.host}/${payload.travellerId}`)
      .pipe(catchError((error) => handleApiError(error)));
  }

  refreshToken(jwtToken: any): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: jwtToken,

      'fleet-product': 'TRAVELLER',
      'fleet-channel': 'WEB',
    });
    return this.nonAuthorisedHttp
      .get<string>(`${this.host}/refreshToken`, {
        headers: headers,
        observe: 'response',
      })
      .pipe(
        map((resp: any) => {
          const newjwt = resp.headers.get('Authorization');
          return newjwt;
        }),
        catchError((error) => of(null))
      );
  }

  findUser(payload: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  usernameInUse(username: string): Observable<any> {
    return of(false);
  }

  resetMFA(payload: any) {
    return this.http
      .post(`${this.host}/${payload.travellerId}/resetMFA`, {})
      .pipe(catchError((error) => handleApiError(error)));
  }
}
